import { EmbedSettings } from './embed-settings';

export { EmbedSettings };
